import { useSetAtom, useAtomValue } from "jotai";
import {
  isUploadingQueueAtom,
  isUploadedQueueAtom,
  addIntelliUploadAtom,
  MAX_FILE_SIZE,
  MAX_FILE_COUNT,
  ALLOWED_FILE_TYPES,
  getIntelliUploadAtom,
  setIntelliUploadAtom,
  removeIntelliUploadAtom,
  uploadIntelliUploadAtom,
  setIntelliUploadQueueIdAtom,
  getIntelliUploadQueueIdAtom,
  updateIntelliUploadAtom,
  clearIntelliUploadAtom,
  isClearingQueueAtom,
  isProcessingQueueAtom,
  processIntelliUploadAtom,
  isProcessedQueueAtom,
  validateIntelliUploadAtom,
  getIntelliUploadProcessedAtom,
  updateIntelliUploadProcessedAtom,
  isRuleEngineTriggeredQueueAtom,
  initiateRuleEngineAtom,
  isRuleEngineInitiatingQueueAtom,
  isProcessedDocumentsValidToProceedAtom,
  processSubmittedAtAtom,
} from "@/store/upload/intelliUpload";

export function useIntelliUpload() {
  const queueId = useAtomValue(getIntelliUploadQueueIdAtom);
  const intelliDocs = useAtomValue(getIntelliUploadAtom);
  const intelliUploadProcessed = useAtomValue(getIntelliUploadProcessedAtom);
  const isUploadingQueue = useAtomValue(isUploadingQueueAtom);
  const isUploadedQueue = useAtomValue(isUploadedQueueAtom);
  const isClearingQueue = useAtomValue(isClearingQueueAtom);
  const isProcessingQueue = useAtomValue(isProcessingQueueAtom);
  const isProcessedQueue = useAtomValue(isProcessedQueueAtom);
  const isRuleEngineTriggeredQueue = useAtomValue(isRuleEngineTriggeredQueueAtom);
  const isRuleEngineInitiatingQueue = useAtomValue(isRuleEngineInitiatingQueueAtom);
  const isProcessedDocumentsValidToProceed = useAtomValue(isProcessedDocumentsValidToProceedAtom);
  const processSubmittedAt = useAtomValue(processSubmittedAtAtom);

  const setIntelliUploadQueueId = useSetAtom(setIntelliUploadQueueIdAtom);
  const setIntelliDocs = useSetAtom(setIntelliUploadAtom);
  const addIntelliDoc = useSetAtom(addIntelliUploadAtom);
  const updateIntelliDoc = useSetAtom(updateIntelliUploadAtom); 
  const removeIntelliDoc = useSetAtom(removeIntelliUploadAtom);
  const uploadDocuments = useSetAtom(uploadIntelliUploadAtom);
  const clearIntelliUpload = useSetAtom(clearIntelliUploadAtom);
  const processIntelliUpload = useSetAtom(processIntelliUploadAtom);
  const validateIntelliUpload = useSetAtom(validateIntelliUploadAtom);
  const updateIntelliUploadProcessed = useSetAtom(updateIntelliUploadProcessedAtom);
  const initiateRuleEngine = useSetAtom(initiateRuleEngineAtom);

  return {
    queueId,
    intelliDocs,
    intelliUploadProcessed,
    isUploadingQueue,
    isUploadedQueue,
    isClearingQueue,
    isProcessingQueue,
    isProcessedQueue,
    isRuleEngineTriggeredQueue,
    isRuleEngineInitiatingQueue,
    isProcessedDocumentsValidToProceed,
    processSubmittedAt,
    setIntelliDocs,
    addIntelliDoc,
    updateIntelliDoc,
    removeIntelliDoc,
    ALLOWED_FILE_TYPES,
    MAX_FILE_SIZE,
    MAX_FILE_COUNT,
    uploadDocuments,
    setIntelliUploadQueueId,
    clearIntelliUpload,
    processIntelliUpload,
    validateIntelliUpload,
    updateIntelliUploadProcessed,
    initiateRuleEngine,
  };
}
